import { useTranslation } from "react-i18next";
import { FaChevronLeft } from "react-icons/fa6";
import Button from "../../../components/buttons/button";
import { useFormik } from "formik";
import TextInput from "../../../components/inputs/textInput";
import Select from "../../../components/select/select";
import { useOptions } from "../../../components/hooks/useOptionsHook";
import DateInput from "../../../components/inputs/dateInput";
import TimeInput from "../../../components/inputs/timeInput";
import TextArea from "../../../components/inputs/textArea";
import FileInput from "./FileInput";
import * as yup from "yup";
import { useNavigate } from "react-router-dom";

const AddActivity = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const validationSchema = yup.object({
    name: yup.string().required(t("required")),
    category: yup.string().required(t("required")),
    allowedCategory: yup.string().required(t("required")),
    startDate: yup.string().required(t("required")),
    time: yup.string().required(t("required")),
    maxSeats: yup.number().required(t("required")),
    desc: yup.string().required(t("required")),
  });
  const formik = useFormik({
    initialValues: {
      name: "",
      category: "",
      allowedCategory: "",
      startDate: "",
      time: "",
      maxSeats: "",
      desc: "",
    },
    validationSchema,
    onSubmit: (values) => {
      console.log(values);
    },
  });
  const { memberShipTypeOptions } = useOptions();
  return (
    <form onSubmit={formik.handleSubmit}>
      <div className="flex flex-wrap items-center justify-between md:flex-nowrap">
        <div className="flex items-center gap-4 my-5">
          <h1
            onClick={() => navigate("/activities")}
            className="text-lg font-bold capitalize cursor-pointer md:text-2xl text-primary"
          >
            {t("activities")}
          </h1>
          <FaChevronLeft className="ltr:rotate-180" />
          <p className="font-bold capitalize">{t("eventsManagement")}</p>
        </div>
        <Button className={"bg-primary text-black"}>{t("add")}</Button>
      </div>

      <article className="px-6 py-8 space-y-4 border border-white rounded-xl">
        <h1 className="my-4 text-lg font-bold capitalize md:text-2xl">
          {t("addEvent")}
        </h1>
        <div className="inputs">
          <TextInput formik={formik} label={t("activityName")} name={"name"} />
          <Select
            options={memberShipTypeOptions}
            formik={formik}
            label={t("category")}
            name={"category"}
          />
        </div>
        <div className="inputs">
          <Select
            options={memberShipTypeOptions}
            formik={formik}
            label={t("allowedCategory")}
            name={"allowedCategory"}
          />
          <DateInput formik={formik} label={t("startDate")} name={"startDate"} />
        </div>
        <div className="inputs">
          <TimeInput formik={formik} label={t("time")} name={"time"} />
          <TextInput number formik={formik} label={t("maxSeats")} name={"maxSeats"} />
        </div>
        <div className="inputs">
          <TextArea formik={formik} label={t("desc")} name={"desc"} />
        </div>
        <FileInput formik={formik} name={"photos"} label={t("photos")} id={"photos"} />
      </article>
    </form>
  );
};

export default AddActivity;
